import React, { useState, useEffect } from "react";
import { baseUrl } from '../shared';
import {
  Button,
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NewTimesheetFlow from "../components/timesheet/NewTimesheetFlow";
import { StatusChip } from "../components/ui";
import './App.css';

function TimesheetReview() {

  const [loginStatus, setLoginStatus] = useState(false);
  const [weekNumber, setWeekNumber] = useState("");
  const [weekData, setWeekData] = useState(null);
  const [weekSelected, setWeekSelected] = useState(false);
  const [dayNumber, setDayNumber] = useState("");
  const [dayData, setDayData] = useState(null);
  const [daySelected, setDaySelected] = useState(false);
  const [dayHours, setDayHours] = useState("");

  useEffect(()=> {
    if (!localStorage.getItem('token')) {
      setLoginStatus(false);
    } else {
      setLoginStatus(true);
    }
  },[]); 

   function getTimesheetsForWeek() {
    const url = baseUrl + 'timesheet/myTimesheets/';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage?.getItem('username'),
        'bToken': localStorage?.getItem('bToken'),
      },
      body: JSON.stringify({weekNumber: weekNumber}),
    })
      .then((res) => {
        return res.json();
      }).then((json) => {
        setWeekData(json);
        setWeekSelected(true)
      })
      .catch((err) => {
        console.error("Error fetching timesheet Data:", err);
      });
};

  function showDayTotals(weekDay, hoursLogged) {
    if(daySelected === false) {
    setDayNumber(weekDay)
    setDayHours(hoursLogged)
    setDaySelected(true)
    getTimesheetsForDay(weekDay)
    } else {
    setDayNumber("")
    setDaySelected(false)
    setDayData(null)
    }
  }

   function getTimesheetsForDay(e) {  
    const url = baseUrl + 'timesheet/myTimesheets/detailed/';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'username': localStorage?.getItem('username'),
        'bToken': localStorage?.getItem('bToken'),
      },
      body: JSON.stringify({weekNumber: weekNumber, dayOfWeek: e}),
    })
      .then((res) => {
        return res.json();
      }).then((json) => {
        setDayData(json);
      })
      .catch((err) => {
        console.error("Error fetching timesheet Data:", err);
      });
};
  
    const DetailField = ({ label, value }) => (
      <Box>
        <Typography variant="caption" sx={{ color: 'var(--muted)', display: 'block' }}>{label}</Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>{value && value !== '-' ? value : '—'}</Typography>
      </Box>
    );

    return (
      <Box sx={{ maxWidth: 640, mx: 'auto', width: '100%' }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.25 }}>View My Timesheets</Typography>
        <Typography variant="body2" sx={{ color: 'var(--muted)', mb: 2 }}>Review your logged hours by week and day.</Typography>

        {!weekSelected ? (
          <Box sx={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow-sm)', p: { xs: 2, sm: 3 } }}>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Select Week</InputLabel>
              <Select
                required
                value={weekNumber}
                label="Select Week"
                onChange={(e) => setWeekNumber(e.target.value)}
              >
                <MenuItem value={0}>Current Week</MenuItem>
                <MenuItem value={1}>Last Week</MenuItem>
              </Select>
            </FormControl>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <Button
                variant="contained"
                onClick={getTimesheetsForWeek}
                disabled={weekNumber === ''}
                sx={{ flex: 1 }}
              >
                Find Timesheets
              </Button>
              <NewTimesheetFlow>
                {(startNew) => (
                  <Button variant="outlined" startIcon={<AddIcon />} onClick={startNew} sx={{ flex: 1 }}>
                    Add Timesheet
                  </Button>
                )}
              </NewTimesheetFlow>
            </Box>
          </Box>
        ) : (
          <Box sx={{ mb: 2 }}>
            <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => { setWeekSelected(false); setDaySelected(false); }}>
              Clear Selected Week
            </Button>
          </Box>
        )}

        {weekSelected && !daySelected ? (
          <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 'var(--r)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-sm)', overflow: 'hidden' }}>
            <Table aria-label="hours by day">
              <TableHead>
                <TableRow sx={{ '& th': { background: 'var(--surface-2)', fontWeight: 700, color: 'var(--text)' } }}>
                  <TableCell>Day</TableCell>
                  <TableCell align="right">Hours</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {weekData.map((list, index) => {
                  const hrs = parseFloat(list.hoursLogged) || 0;
                  return (
                    <TableRow key={index} hover sx={{ cursor: 'pointer', opacity: hrs > 0 ? 1 : 0.55 }} onClick={() => showDayTotals(list.weekDay, list.hoursLogged)}>
                      <TableCell>{list.weekDay}</TableCell>
                      <TableCell align="right" className="aims-mono" sx={{ fontWeight: hrs > 0 ? 600 : 400 }}>{hrs.toFixed(2)} h</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : null}

        {daySelected ? (
          <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, p: 2, background: 'var(--surface-2)', border: '1px solid var(--border)', borderRadius: 'var(--r)' }}>
              <Box>
                <Button variant="text" size="small" startIcon={<ArrowBackIcon />} onClick={() => showDayTotals()} sx={{ mb: 0.5, ml: -0.5, color: 'var(--muted)' }}>Back to week</Button>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>{dayNumber}</Typography>
              </Box>
              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="caption" sx={{ color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: '.5px', fontWeight: 600 }}>Total hours</Typography>
                <Typography className="aims-mono" sx={{ fontSize: 24, fontWeight: 700 }}>
                  {(parseFloat(dayHours) || 0).toFixed(2)}<Typography component="span" sx={{ fontSize: 13, color: 'var(--faint)', ml: 0.5 }}>h</Typography>
                </Typography>
              </Box>
            </Box>

            {(!dayData || dayData.length === 0) ? (
              <Typography variant="body2" sx={{ color: 'var(--muted)', textAlign: 'center', py: 3 }}>No timesheets logged for {dayNumber}.</Typography>
            ) : dayData.map((list, index) => (
              <Box
                key={index}
                onClick={() => { window.location.href = `${window.location.origin}?assetNo=${list.assetId}`; }}
                sx={{ cursor: 'pointer', mb: 1.5, p: 2, background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', boxShadow: 'var(--shadow-sm)', '&:hover': { borderColor: 'var(--primary)' } }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 }}>
                  <Box>
                    <Typography className="aims-mono" sx={{ fontWeight: 700, fontSize: 15 }}>{list.assetId}</Typography>
                    <Typography variant="caption" sx={{ color: 'var(--muted)' }}>Cat No: <span className="aims-mono">{list.catNo}</span></Typography>
                  </Box>
                  <Box sx={{ textAlign: 'right' }}>
                    <StatusChip domain="job" value={list.status} />
                    <Typography className="aims-mono" sx={{ fontWeight: 700, mt: 0.5 }}>{list.timeSpent} h</Typography>
                  </Box>
                </Box>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mt: 1.5 }}>
                  <DetailField label="Job Card" value={list.jobCard} />
                  <DetailField label="Purchase Order" value={list.purchaseOrder} />
                  <DetailField label="Line Item" value={list.lineItem} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : null}
      </Box>
    );
  }

export default TimesheetReview